import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['token'] as const

export type sztgCredType = (typeof credentialTypes)[number]

export const sztgDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const sztg: CarrierDef<sztgCredType> = {
  name: 'Speedy Transport',
  scac: 'sztg',
  credentialTypes,
  legacyCredMap: [['token', 'token']],
  engineLayers: ['documents'],
  documentTypes: sztgDocumentTypes,
}
